<template>
    <div class="card card-custom">
        <div class="card-header">
            <h3 class="card-title">Kho video buổi học {{ lessonNumber }}</h3>
            <div class="card-toolbar">
                <el-button type="success" size="small" @click="openCreate">Thêm mới</el-button>
            </div>
        </div>
        <div class="card-body">
            <el-row :gutter="20">
                <el-col :span="7">
                    <label>Tên video</label>
                    <el-input v-model="filters.search" placeholder="Nhập tên video" clearable />
                </el-col>
                <el-col :span="7">
                    <label>Trung tâm áp dụng</label>
                    <el-select v-model="filters.center_id" placeholder="Chọn trung tâm áp dụng" clearable filterable style="width: 100%">
                        <el-option v-for="item in centers" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <label>Trạng thái</label>
                    <el-select v-model="filters.status" placeholder="Chọn trạng thái" clearable style="width: 100%">
                        <el-option :value="1" label="Hiển thị" />
                        <el-option :value="0" label="Ẩn" />
                    </el-select>
                </el-col>
                <el-col :span="4" style="padding-top: 22px">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">Tìm kiếm</el-button>
                </el-col>
            </el-row>

            <el-table :data="videos" v-loading="loading" style="margin-top: 20px">
                <el-table-column label="STT" type="index" :index="indexFn" width="70" />
                <el-table-column label="Tên video" prop="name" />
                <el-table-column label="Trung tâm áp dụng">
                    <template slot-scope="{ row }">{{ renderCenters(row.centerIds) }}</template>
                </el-table-column>
                <el-table-column label="Trạng thái" width="120">
                    <template slot-scope="{ row }">
                        <span :class="row.status ? 'badge badge-success' : 'badge badge-danger'">
                            {{ row.status ? "Hiển thị" : "Ẩn" }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="Người upload">
                    <template slot-scope="{ row }">
                        <span v-if="row.creator">{{ employeeId(row.creator.id) }} - {{ row.creator.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Thời gian upload" width="180">
                    <template slot-scope="{ row }">{{ formatDate(row.createdAt) }}</template>
                </el-table-column>
                <el-table-column label="Hành động" width="140">
                    <template slot-scope="{ row }">
                        <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="openEdit(row)" />
                        <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="confirmDelete(row)" />
                    </template>
                </el-table-column>
            </el-table>

            <div style="margin-top: 20px; text-align: center">
                <el-pagination background layout="prev, pager, next" :total="pagination.total || 0" :page-size="pagination.per_page || 15" :current-page.sync="pagination.current_page" @current-change="fetchList" />
            </div>
        </div>

        <guarantee-video-dialog :visible.sync="dialogVisible" :video-data="editing" :centers="centers" :schedule-learning-id="scheduleLearningId" :lesson="lessonNumber" :course-id="courseId" @success="onDialogSuccess" />
    </div>
</template>

<script>
import moment from "moment";
import { GET_GUARANTEE_VIDEO_CENTERS } from "@/core/services/store/center/centers.module";
import { GUARANTEE_VIDEO_LIST, GUARANTEE_VIDEO_DELETE } from "@/core/services/store/guarantee-video/guaranteeVideo.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import GuaranteeVideoDialog from "./component/guarantee-video-dialog.vue";

export default {
    name: "GuaranteeVideoPage",
    components: { GuaranteeVideoDialog },
    data() {
        return {
            loading: false,
            videos: [],
            centers: [],
            pagination: { current_page: 1, per_page: 15, total: 0 },
            filters: { search: "", center_id: null, status: null },
            dialogVisible: false,
            editing: null,
        };
    },
    computed: {
        scheduleLearningId() { return this.$route.params.id; },
        lessonNumber() { return this.$route.query.lesson || ''; },
        courseId() { return this.$route.query.course_id || this.$route.query.course; }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Quản lý lộ trình", route: "schedule-course-list" },
            { title: "Chi tiết lộ trình", route: "schedule-course-detail" },
            { title: "Danh sách video" }
        ]);
        this.$store.dispatch(GET_GUARANTEE_VIDEO_CENTERS).then((res) => {
            this.centers = res?.data || [];
        });
        this.fetchList();
    },
    methods: {
        employeeId(id) { return id ? +id + 100000 : ""; },
        indexFn(i) { return (this.pagination.current_page - 1) * this.pagination.per_page + i + 1; },
        formatDate(d) { return d ? moment(d).format("HH:mm:ss DD-MM-YYYY") : ""; },
        renderCenters(ids) {
            if (!Array.isArray(ids) || !ids.length) return "";
            return ids.map((id) => { const c = this.centers.find((x) => x.id === id); return c ? c.name : id; }).join(", ");
        },
        onSearch() { this.pagination.current_page = 1; this.fetchList(); },
        async fetchList() {
            this.loading = true;
            const params = {
                learning_schedule_id: this.scheduleLearningId,
                lesson: this.lessonNumber,
                search: this.filters.search || undefined,
                center_id: this.filters.center_id || undefined,
                status: this.filters.status === null ? undefined : this.filters.status,
                page: this.pagination.current_page,
                per_page: this.pagination.per_page,
            };
            try {
                const res = await this.$store.dispatch(GUARANTEE_VIDEO_LIST, params);
                this.videos = res?.data || [];
                if (res?.meta) {
                    this.pagination.total = res.meta.total || 0;
                    this.pagination.per_page = res.meta.per_page || 15;
                }
            } catch (e) {
                this.$message.error("Không tải được danh sách video");
            } finally {
                this.loading = false;
            }
        },
        openCreate() { this.editing = null; this.dialogVisible = true; },
        openEdit(row) { this.editing = { ...row }; this.dialogVisible = true; },
        confirmDelete(row) {
            this.$confirm("Bạn chắc chắn muốn gỡ video?", "Xác nhận", {
                confirmButtonText: "Đồng ý", cancelButtonText: "Không", type: "warning"
            }).then(async () => {
                try {
                    await this.$store.dispatch(GUARANTEE_VIDEO_DELETE, row.id);
                    this.$message.success("Xóa video thành công");
                    this.fetchList();
                } catch (e) {
                    this.$message.error("Xóa thất bại");
                }
            }).catch(() => {});
        },
        onDialogSuccess() { this.fetchList(); }
    }
};
</script>
